module.exports = __webpack_public_path__ + "static/media/ic_info.00d81373.png";